var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
      _vm.canOpen
        ? _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button" },
              on: { click: _vm.openFile },
            },
            [_c("i", { staticClass: "far fa-folder-open" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canRecord
        ? _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button" },
              on: { click: _vm.record },
            },
            [_c("i", { staticClass: "fas fa-microphone" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canStop
        ? _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button" },
              on: { click: _vm.stop },
            },
            [_c("i", { staticClass: "fas fa-stop" })]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      staticClass: "d-none",
      attrs: { type: "file" },
      on: { change: _vm.fileSelect },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }